/**
 * navigationConfig.js
 *
 * Target-adapted mobile navigation configuration for Magdump.
 */

import {
  IoWatchOutline,
  IoDesktopOutline,
  IoHomeOutline,
  IoMailOutline,
  IoDocumentTextOutline } from
'react-icons/io5';

export const PRODUCTS = [
{
  id: 'hardware',
  label: 'Hardware',
  shortLabel: 'Hardware',
  path: '/hardware',
  icon: IoDesktopOutline,
  accentColor: 'var(--gold)'
},
{
  id: 'event',
  label: 'Event',
  shortLabel: 'Event',
  path: '/event',
  icon: IoWatchOutline,
  accentColor: '#f2d67b'
},
{
  id: 'journal',
  label: 'Journal',
  shortLabel: 'Journal',
  path: '/journal',
  icon: IoDocumentTextOutline,
  accentColor: '#d8d8d2'
}];

export const HOME_SECTIONS = [];

export const UTILITIES = [
{
  id: 'contact',
  label: 'Contact',
  path: '/contact',
  icon: IoMailOutline
}];

export const getPageContext = (pathname) => {
  const path = pathname.toLowerCase();

  if (path === '/') {
    return { pageType: 'home', currentId: 'home', isProductPage: false };
  }

  const product = PRODUCTS.find((p) => p.path === path);
  if (product) {
    return { pageType: 'product', currentId: product.id, isProductPage: true };
  }

  const utility = UTILITIES.find((u) => {
    if (u.pathMatch) {
      return path.startsWith(u.pathMatch);
    }
    return u.path === path;
  });
  if (utility) {
    return { pageType: 'utility', currentId: utility.id, isProductPage: false };
  }

  return { pageType: 'other', currentId: null, isProductPage: false };
};

export const DEFAULT_CONFIG = {
  expandHomeSections: true,
  showGroupHeaders: true,
  animationDuration: 200
};

export default {
  PRODUCTS,
  HOME_SECTIONS,
  UTILITIES,
  getPageContext,
  DEFAULT_CONFIG
};
